/* eslint-disable no-undef */
import $ from "jquery";

const add2cart = () => {
  const init = () => {
    handleClickButton();
  };

  const handleClickButton = () => {
    const el = {
      button: ".js-add2cart",
      counterEl: ".js-counter-cart",
      minicart: ".js-minicart",
    };

    if ($(el.button).length === 0) return;

    $(document).on("click", el.button, function (e) {
      e.preventDefault();

      const dataFor = $(this).data("for");
      const productId = $(this).data("product_id");
      const productType = $(this).data("product_type");
      const qty = $(`#${dataFor}`).val();
      const thisEl = $(this);

      $.ajax({
        type: "POST",
        dataType: "json",
        url: themeObj.ajaxUrl,
        data: {
          action: themeObj.add2cart.action,
          nonce: themeObj.add2cart.nonce,
          product_id: productId,
          active_user_type: productType,
          quantity: qty,
        },
        beforeSend() {
          thisEl.addClass("loading_text");
          thisEl.find("span").text(thisEl.data("loading_text"));
        },
        success(response) {
          if (!response.success) {
            alert(response.data);
            return;
          }
          const parentEl = thisEl.parent();
          const input = parentEl.find(".js-number input");
          const btnMinus = parentEl.find(".js-product-button-minus");
          const btnPlus = parentEl.find(".js-product-button-plus");

          btnMinus.removeClass("disabled");
          btnPlus.removeClass("disabled");
          input.val(1);
          animation(thisEl);
          const counter = response.data.count;
          const html = response.data.html;
          $(el.counterEl).text(counter);
          $(el.minicart).html(html);
        },
        error(response) {
          if (response.responseJSON.data.redirect) {
            window.location.href = response.responseJSON.data.redirect;
          }
        },
        complete() {
          thisEl.removeClass("loading");
          thisEl.find("span").text(thisEl.data("text"));
        },
      });
    });
  };

  const animation = (thisEl) => {
    const toPosition = $(".js-menu-cart").offset();
    const topEl = thisEl.offset().top - $(window).scrollTop();
    const product = thisEl.parents(".list-product");
    const image = product.find(".wrapper-img img");
    const temp_id = new Date().getTime() + "image-for-animation";
    image.clone().prop("id", temp_id).appendTo("body");

    const newImage = $(`#${temp_id}`);

    newImage
      .css("position", "fixed")
      .css("left", `${thisEl.offset().left}px`)
      .css("top", `${topEl}px`)
      .css("height", `50px`)
      .css("width", `50px`)
      .css("border-radius", `50px`)
      .css("opacity", 1);

    newImage.animate(
      {
        top: 30 + "px",
        left: toPosition.left + "px",
        opacity: 0.2,
        width: "20px",
        height: "20px",
      },
      1000,
      function () {
        newImage.remove();
      }
    );
  };

  init();
};

try {
  add2cart();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
